import Image from "next/image";
import Footer from "./layout/footer";
import Header from "./layout/header";
import React from "react";
import { Trans } from "@lingui/macro";
import { Position } from "./careers-page/job-available";

interface SelectedPosition {
  selectedPosition: Position;
}

const JobPostPage: React.FunctionComponent<SelectedPosition> = ({
  selectedPosition,
}) => {
  return (
    <>
      <Header showNewsStacks={false} />
      <div className="bg-off-white">
        {/* <div className="relative mx-auto mb-4 h-52 max-w-4xl md:mb-6"> */}
        <div className="relative mx-auto mb-4 w-full max-w-[2500px] md:mb-6 lg:h-[800px]">
          {/* eslint-disable @next/next/no-img-element */}
          <div className="block lg:hidden">
            <img
              className="w-full"
              src={selectedPosition.heroImage}
              alt="job-post-hero-image"
            />
          </div>
          <div className="hidden lg:block">
            <Image
              src={selectedPosition.heroImageLarge}
              alt="job-post-hero-image"
              layout="fill"
              objectFit="cover"
              objectPosition={"top"}
              priority
            />
          </div>
        </div>
        {selectedPosition && (
          <div className="mx-auto max-w-4xl">
            <div className="mt-6 mb-4 w-full justify-between md:flex">
              <div className="px-4 md:mr-48">
                <p className="mb-4 flex-1 font-poppins text-2xl font-bold">
                  {selectedPosition.role.emoji} {selectedPosition.role.position}
                </p>
                <div className="no-scrollbar flex flex-nowrap overflow-x-scroll md:flex-wrap">
                  {selectedPosition.categories.map((category) => (
                    <div
                      key={category.key}
                      className="mr-2 whitespace-nowrap rounded-full bg-text-medium px-4 py-2 font-sen text-sm  text-white md:mb-2"
                    >
                      {category.name}
                    </div>
                  ))}
                </div>
              </div>
              <div className="fixed bottom-0 z-10 w-full rounded-t-xl bg-white py-4 md:relative md:hidden">
                <div className="mx-auto w-10/12 rounded-lg bg-primary px-2 py-4 text-center font-sen text-white">
                  <a href="mailto: work@luminews.my">
                    <Trans>Apply Now</Trans>
                  </a>
                </div>
              </div>
              <div className="hidden md:mr-4 md:block">
                <div className="whitespace-nowrap rounded-2xl bg-primary px-6 py-4 text-center font-sen text-white">
                  <a href="mailto: work@luminews.my">
                    <Trans>Apply Now</Trans>
                  </a>
                </div>
              </div>
            </div>
            <div className="mx-auto max-w-4xl border-b-2 border-[#E9EDF7]"></div>
            <div className="mx-auto mt-4 w-full max-w-4xl px-4">
              <p className="font-poppins text-2xl font-bold">
                <Trans>The Role</Trans>
              </p>
            </div>
            <div className="mx-auto mt-2 mb-4 flex w-full max-w-4xl flex-col px-4 font-sen">
              <div className="mb-2 flex">
                <div className="w-36 basis-1/2 md:basis-1/3">
                  <Trans>Position</Trans>
                </div>
                <div className="basis-1/2">
                  : {selectedPosition.role.position}
                </div>
              </div>
              <div className="mb-2 flex">
                <div className="w-36 basis-1/2 md:basis-1/3">
                  <Trans>Salary</Trans>
                </div>
                <div className="basis-1/2">
                  : {selectedPosition.role.salary}
                </div>
              </div>
              <div className="mb-2 flex">
                <div className="w-36 basis-1/2 md:basis-1/3">
                  <Trans>Location</Trans>
                </div>
                <div className="basis-1/2">
                  : {selectedPosition.role.location}
                </div>
              </div>
              <div className="mb-2 flex">
                <div className="w-36 basis-1/2 md:basis-1/3">
                  <Trans>Working Hours</Trans>
                </div>
                <div className="flex-1">
                  : {selectedPosition.role.workinghours}
                </div>
              </div>
            </div>
            <div className="mx-auto mb-10 flex max-w-4xl flex-col px-4">
              <p className="mb-4 font-poppins text-2xl font-bold">
                <Trans>What you'll be doing</Trans>
              </p>
              <div className="ml-4 font-sen">{selectedPosition.todos}</div>
            </div>
            {selectedPosition.requirement && (
              <div className="mx-auto mb-10 flex max-w-4xl flex-col px-4">
                <p className="mb-4 font-poppins text-2xl font-bold">
                  <Trans>Requirements we're looking for</Trans>
                </p>
                <div className="ml-4 font-sen">
                  {selectedPosition.requirement}
                </div>
              </div>
            )}
            {selectedPosition.nonTechRequirement && (
              <div className="mx-auto mb-10 flex max-w-4xl flex-col px-4">
                <p className="mb-4 font-poppins text-2xl font-bold">
                  <Trans>The non-technical things that matter</Trans>
                </p>
                <div className="ml-4 font-sen">
                  {selectedPosition.nonTechRequirement}
                </div>
              </div>
            )}
            {selectedPosition.team && (
              <div className="mx-auto mb-10 max-w-4xl px-4">
                <p className="mb-4 font-poppins text-2xl font-bold">
                  <Trans>Who you'll be working with</Trans>
                </p>
                <div className="ml-4 font-sen">{selectedPosition.team}</div>
              </div>
            )}
            <div className="mx-auto mb-10 max-w-4xl px-4">
              <p className="mb-4 font-poppins text-2xl font-bold">
                <Trans>Perks of working here</Trans>
              </p>
              <div className="ml-4 font-sen">
                <ul className="list-disc">
                  <li>
                    <b>
                      🏠 <Trans>Hybrid working</Trans>:{" "}
                    </b>
                    <Trans>
                      We’re currently working 3 days in the office and 2 days at
                      home.
                    </Trans>
                  </li>
                  <li>
                    <b>
                      🏝 <Trans>Paid leaves</Trans>:{" "}
                    </b>
                    <Trans>
                      From 18 days of annual leave & more, we care about you
                      having a life outside!
                    </Trans>
                  </li>
                  <li>
                    <b>
                      🎂 <Trans>Birthday leave</Trans>:{" "}
                    </b>
                    <Trans>
                      Take a day off work on your birthday every year! This is
                      in addition to your annual leave.
                    </Trans>
                  </li>
                  <li>
                    <b>
                      🔌 <Trans>Gadget allowance</Trans>:{" "}
                    </b>
                    <Trans>
                      RM200 monthly fixed allowance for your gadget expenses. No
                      receipts needed.
                    </Trans>
                  </li>
                  <li>
                    <b>
                      🚗 <Trans>Parking allowance</Trans>:{" "}
                    </b>
                    <Trans>
                      RM150 a month to cover your parking and commuting expenses
                      - even if you don't drive. No questions asked.
                    </Trans>
                  </li>

                  <li>
                    <b>
                      🏥 <Trans>Healthcare</Trans>:{" "}
                    </b>
                    <Trans>
                      Take care of your health with a RM100 monthly fixed
                      allowance, on top of medical claims of up to RM200 every
                      quarter.
                    </Trans>
                  </li>
                  <li>
                    <b>
                      🎨 <Trans>App subscriptions</Trans>:{" "}
                    </b>
                    <Trans>
                      RM150 per month for software subscriptions or you can sign
                      up for a course!
                    </Trans>
                  </li>
                  <li>
                    <b>
                      🏸 <Trans>Weekly activities</Trans>:{" "}
                    </b>
                    <Trans>
                      Work hard play hard with our team lunches, badminton
                      matches, & more!
                    </Trans>
                  </li>
                  <li>
                    <b>
                      👋 <Trans>Friendly peeps</Trans>:{" "}
                    </b>
                    <Trans>
                      Our awesome crew of course, what’s a better reason?
                    </Trans>
                  </li>
                </ul>
              </div>
            </div>
            <div className="mx-auto mb-10 max-w-4xl px-4">
              <p className="mb-4 font-poppins text-2xl font-bold">
                <Trans>Apply now</Trans>
              </p>
              {selectedPosition.application}
            </div>
          </div>
        )}
        <Footer />
      </div>
    </>
  );
};

export default JobPostPage;
